function getShortageDamageUnits() {
  return { MT: 'MT', PCE_CASE: 'PCE/CASE', QUANTITY_UNIT: 'QUANTITY UNIT', PCE_TO_QUANTITY_UNIT: 'PCE TO QUANTITY UNIT' };
}

function getPositions() {
  return { Horizontal: 'Horizontal', Vertical: 'Vertical' };
}

function getShortageDamageUnitsAsList() {
  return Object.values(getShortageDamageUnits());
}

const cartonDamageType = {
  'Fixed Price': 1,
  'Material MRP': 2,
  'Material Invoice': 3,
  'Qty + Amount': 4,
};

const materialCategoriesConstant = {
  validMaterialCategoriesHeader: {
    Name: 'name',
    Cluster: 'cluster',
    'Stacking Norms': 'stacking_norms',
    'Positioning Constraints': 'positioning_constraints',
    'Shortage Unit': 'shortage_unit',
    'Damage Unit': 'damage_unit',
    'Carton Damage Unit': 'carton_damage_unit',
    'Carton Damage Type': 'carton_damage_type',
    'Carton Damage Factor': 'carton_damage_factor',
    'GST Exempt': 'gst_exempt',
    'Shortage Tolerance': 'shortage_tolerance',
    'Damage Tolerance': 'damage_tolerance',
    'Optima Floor 2': 'optima_floor2',
    'Optima Group': 'optima_group',
    'Max Utilization': 'max_utilization',
    'Shortage Type': 'shortage_type',
    'Shortage Factor': 'shortage_factor',
    'Damage Type': 'damage_type',
    'Damage Factor': 'damage_factor',
  },
  validAdditionalMaterialCategoriesHeader: {
    Name: 'name',
    'Type(Exclude/Sub-Category)': 'type',
    Value: 'value',
  },
  materialCategoryAdditionalUploadTypes: {
    subCategory: 'sub-category',
    exclude: 'exclude',
  },
};

module.exports = {
  getShortageDamageUnits, getShortageDamageUnitsAsList, getPositions, materialCategoriesConstant, cartonDamageType
};
